module.exports = __webpack_public_path__ + "img/lolita-1.5bdc426e.jpg";